import { render, staticRenderFns } from "./userExpeditingDelivery.vue?vue&type=template&id=73f91c5b&scoped=true"
import script from "./userExpeditingDelivery.vue?vue&type=script&lang=js"
export * from "./userExpeditingDelivery.vue?vue&type=script&lang=js"
import style0 from "./userExpeditingDelivery.vue?vue&type=style&index=0&id=73f91c5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f91c5b",
  null
  
)

export default component.exports